/**
 * Point de sortie unique vers `Math` pour tout le noyau (CLAUDE.md §5).
 *
 * Aucun autre fichier de `src/core/**` n'a le droit d'appeler `Math.*` — la
 * règle de lint `verlet/no-host-math` le vérifie. Raison : les fonctions
 * transcendantes de l'hôte ne sont pas spécifiées bit-à-bit par IEEE-754 et
 * diffèrent d'un moteur à l'autre. Les concentrer ici permettra de les
 * remplacer par des implémentations polynomiales le jour où la reproductibilité
 * inter-plateformes deviendra un objectif, sans toucher au reste du noyau.
 *
 * On n'expose que ce dont le noyau se sert réellement.
 */

export const PI = Math.PI;

export function abs(x: number): number {
  return Math.abs(x);
}

export function floor(x: number): number {
  return Math.floor(x);
}

export function sin(x: number): number {
  return Math.sin(x);
}

export function cos(x: number): number {
  return Math.cos(x);
}

export function asin(x: number): number {
  return Math.asin(x);
}

export function atan2(y: number, x: number): number {
  return Math.atan2(y, x);
}

export function tan(x: number): number {
  return Math.tan(x);
}

export function sqrt(x: number): number {
  return Math.sqrt(x);
}

export function round(x: number): number {
  return Math.round(x);
}

export function max(a: number, b: number): number {
  return Math.max(a, b);
}

/**
 * `pow` sert au champ de gravitation à exposant réglable, où l'exposant n'est
 * pas entier : `r ** 2.4` ne se ramène à aucune multiplication.
 */
export function pow(base: number, exponent: number): number {
  return Math.pow(base, exponent);
}
